import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";
import { setHideConfirmModal, updateUserStatus } from "./userSlice";


export const FetchUsers = createAsyncThunk(
  "FetchUsers",
  async ({ page, usersPerPage, query = "" }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).get(`user/users?page=${page}&limit=${usersPerPage}&search=${query}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)

      return rejectWithValue(error.response.data);
    }
  }
);


export const UpdateUserStatus = createAsyncThunk(
  "UpdateUserStatus",
  async ({ id, isBlocked }: any, { rejectWithValue, dispatch, getState }) => {
    try {

      const response = await customAxios('application/json', dispatch).put(`user/${id}/status`, { isBlocked });
      successMessage(response.data.message['details'])
      dispatch(updateUserStatus({ id, isBlocked }))
      dispatch(setHideConfirmModal())
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.responseMessage || SOME_WENT_WRONG)

      return rejectWithValue(error.response.data);
    }
  }
);






